import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@store";

export const selectDialogs = (state: RootState) => state.dialogs;

export const getDialogProps = <T>(id: string) =>
  createSelector(
    selectDialogs,
    (dialogs) =>
      dialogs.find((dialog) => dialog.id === id)?.props as T | undefined,
  );

export const isDialogOpen = (id: string) =>
  createSelector(selectDialogs, (dialogs) =>
    dialogs.some((dialog) => dialog.id === id),
  );

export const selectIsAnyDialogOpen = createSelector(
  selectDialogs,
  (dialogs) => dialogs.length > 0,
);
